<template>
  <aha-modal
    :title="$i18nPresenter.t('Let’s Level Up!')"
    @hide="handleCloseModal()"
    noCloseOnBackdrop
    v-if="!isCheckLocalShowModal && listBenefits.length"
  >
    <div>
      <p>
        {{ $i18nPresenter.t(
          'Some settings in this presentation are part of our premium plan and will be disabled:'
        ) }}
      </p>
      <div class="mt-4 mb-4">
        <ul class="pl-4">
          <li v-for="(item, index) in listBenefits" class="font-bold mb-2" :key="index">
            <img
              src="@/assets/images/pro.svg"
              class="cursor-pointer mr-1 mb-1 inline-block"
            > {{ $i18nPresenter.t(item) }}
          </li>
        </ul>
      </div>
      <p>{{ $i18nPresenter.t('Please upgrade to unlock the full experience!') }}</p>
    </div>
    <template #action>
      <aha-button
        variant="success"
        @click="openPlanUpgradeModal()"
      >
        {{ $i18nPresenter.t('Upgrade') }}
      </aha-button>
      <aha-link
        class="font-bold"
        has-margin-left
        @click="handleCloseModalNoThank()"
      >
        {{ $i18nPresenter.t('No, thanks') }}
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import PlanBenefitAPI from '@/api/planBenefit'
import Util from '@/util'
import * as localStorageExpiry from '@/utils/local.storage.expiry'

export default {
  name: 'HandleCopyPlanBenefitModal',
  data() {
    return {
      listBenefits: [],
      isCheckLocalShowModal: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    try {
      this.isCheckLocalShowModal = localStorageExpiry.getWithExpiry(`prez-plan-benefit-${this.presentation.id}`)
    } catch (error) {
      Sentry.captureException(error)
    }
    if (!this.isCheckLocalShowModal) {
      this.getDataHandleCopyPlanBenefit()
    }
  },
  methods: {
    async getDataHandleCopyPlanBenefit() {
      try {
        const resp = await PlanBenefitAPI.getDataPresentationHandleCopyPlanBenefit(this.presentation.id)
        if (resp.length > 0) {
          this.listBenefits = resp
          this.isCheckLocalShowModal = false
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    handleCloseModal() {
      this.isCheckLocalShowModal = true
    },
    handleCloseModalNoThank() {
      this.isCheckLocalShowModal = true
      localStorageExpiry.setWithExpiry(`prez-plan-benefit-${this.presentation.id}`, true, 365 * 24 * 60 * 60 * 1000)
    },
    openPlanUpgradeModal() {
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      this.handleCloseModal()
      Util.mixpanelTracking(
        this.source,
        'Feature upgrade',
        'Handle Copy Presentation',
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          plan: this.currentUser.plan,
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
